<template>
  <div :class="`milestone-list-entry ${color}`">
    <slot/>
  </div>
</template>
<script>
  export default {
    props: ['color']
  }
</script>
<style>
  .milestone-list-entry {
    position: relative;
    display: flex;
    height: 50px;
    width: 100%;
    border-bottom: 1px solid var(--v-color-3-base);
    align-items: center;
    padding: 3px;
    background-color: var(--v-color-4-base);
    cursor: pointer;
    transition: background-color 0.075s ease-in-out;
  }
  .milestone-list-entry:hover {
    background-color: var(--v-color-3-base);
  }
</style>
